import { fabric } from 'fabric';
import { triggerStateChangedRequest } from '~core/triggerStateChangedRequest';
import { getState, modifyState } from '~src/state';

export default function addCanvasObjectsFromJSON(json) {
  const vCanvas = new fabric.Canvas();

  const isSameCanvas = window.editorLoader.canvasId === json.canvasId;
  delete json.canvasId;

  vCanvas.loadFromJSON(json, () => {
    const wasCanvasHistoryPaused = getState('pauseCanvasHistory', false);
    modifyState('pauseCanvasHistory', true);

    try {
      vCanvas.forEachObject((obj) => {
        if (isSameCanvas) {
          obj.set({
            top: obj.top + 10,
            left: obj.left + 10,
          });
        }

        window.canvas.add(obj);
      });

      window.canvas.renderAll();
    } finally {
      modifyState('pauseCanvasHistory', wasCanvasHistoryPaused);
    }

    // Registra l'intero batch una volta sola, incluse le MagicFrame che non
    // generano uno snapshot tramite object:added.
    triggerStateChangedRequest();
  });
}
